import * as _ from 'lodash';
import { bytesToKiloBytes, millisecondsToSeconds } from '../utils/utils';
import { SimpleMapper } from './simple.mapper';
import IProcessCalculationStatisticDTO = ZoningAPI.IProcessCalculationStatisticDTO;
import { IProcessCalculationStatistic } from '../interfaces/process-calculation-statistic.interface';

export class ProcessCalculationStatisticMapper extends SimpleMapper<
    IProcessCalculationStatisticDTO,
    IProcessCalculationStatistic
> {
    fromDTOFields = [
        'ThreadsCount',
        'BunchSize',

        'CalcTimeMs',
        'SaveToDBTimeMs',
        'SrvCalcTimeMs',
        'DataLoadTimeMs',
        'CRsInPeriod',
        'CRsPerHour',
        'createdAt',
        'GISCalcTimeMs',
        'TotalTimeMs',
        'TransferTimeMs',

        'CRsStatuses',
        'TotalCRs',
        'AVGCRsPerHour',
        'TotalCRsStatuses',
        'AVGCalcTimeMs',
        'AVGSaveToDBTimeMs',
        'AVGSrvCalcTimeMs',
        'AVGDataLoadTimeMs',

        'AVGGISCalcTimeMs',
        'AVGTotalTimeMs',
        'AVGTransferTimeMs',

        'TotalPRsInProgress',
        'CRsPerHourPerThread',

        'GAPIDataLoadDuration',
        'WaitForDataDuration',
        'DataSetsCached',
        'CachingIterationsCount',

        'DesiredPRsCount',
        'DesiredAbuttingPRsCount',
        'DesiredStreetsCount',
        'DesiredPRTagsCount',

        'CachedPropertyRecordsCount',
        'CachedAbuttingPRsCount',
        'CachedStreetsCount',
        'CachedPRTagsCount',

        'RequestedPropertyRecordsCount',
        'RequestedAbuttingPRsCount',
        'RequestedStreetsCount',
        'RequestedPRTagsCount',

        'CacheSize',
        'CalculatedCacheSizeBytes',

        'ReceivedPropertyRecordsCount',
        'ReceivedAbuttingPRsCount',
        'ReceivedStreetsCount',
        'ReceivedPRTagsCount',

        'MissedPropertyRecordsCount',
        'MissedAbuttingPRsCount',
        'MissedStreetsCount',
        'MissedPRTagsCount'
    ];

    fromDTO(dto: IProcessCalculationStatisticDTO): IProcessCalculationStatistic {
        if (!dto) {
            return null;
        }

        const result = super.fromDTO(dto);

        result.GAPIDataLoadDuration = millisecondsToSeconds(dto.GAPIDataLoadDuration);
        result.WaitForDataDuration = millisecondsToSeconds(dto.WaitForDataDuration);
        result.CalculatedCacheSizeBytes = bytesToKiloBytes(dto.CalculatedCacheSizeBytes);

        return result;
    }
}
